import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const InitialForm = lazy(() =>
  import(
    /* webpackChunkName: "ConsultationInitialForm" */ /* webpackPrefetch: true */ "./new/page"
  ).then((module) => ({ default: module.Page })),
);

const ConsultationLayout = lazy(() =>
  import(
    /* webpackChunkName: "ConsultationLayout" */ /* webpackPrefetch: true */ "./layout"
  ).then((module) => ({ default: module.default })),
);

const Review = lazy(() =>
  import(
    /* webpackChunkName: "ConsultationReview" */ /* webpackPrefetch: true */ "./new/review/page"
  ).then((module) => ({ default: module.Page })),
);

export const NewConsultationRoutes = () => (
  <Routes>
    <Route path="new" element={<ConsultationLayout />}>
      <Route index element={<InitialForm />} />
      <Route path="review" element={<Review />} />
    </Route>
  </Routes>
);
